import React, { Component } from 'react';
import { StripeProvider, injectStripe, Elements } from 'react-stripe-elements';

import configureDecoratedComponent from 'client/helpers/configureDecoratedComponent';
import withJsScript from 'client/helpers/withJsScript';
import branch from 'client/core/branch';

export default function withUtilityStripeDecorator(ComponentToDecorate) {
  const ComponentToDecorateWithStripe = injectStripe(ComponentToDecorate);

  @withJsScript({
    preventRender: true,
    scriptUrl: 'https://js.stripe.com/v3/',
  })
  @branch({
    UTILITY_STRIPE_API_KEY: ['env', 'UTILITY_STRIPE_API_KEY'],
  })
  class withUtilityStripe extends Component {
    render() {
      const { UTILITY_STRIPE_API_KEY } = this.props;

      if (!UTILITY_STRIPE_API_KEY) {
        return <div>Sorry, Stripe is not enabled in this Utility Profit environment.</div>;
      }

      return (
        <StripeProvider stripe={null} apiKey={UTILITY_STRIPE_API_KEY}>
          <Elements>
            <ComponentToDecorateWithStripe {...this.props} />
          </Elements>
        </StripeProvider>
      );
    }
  }

  configureDecoratedComponent({
    DecoratedComponent: withUtilityStripe,
    OriginalComponent: ComponentToDecorate,
    displayNameSuffix: 'withUtilityStripe',
  });

  return withUtilityStripe;
}
